import ModalViewModel from 'infra/ModalViewModel'
import { BookkeepingCycle } from 'jobs/bookkeeping/BookkeepingProgressionInfo'
import BookkeepingProgressionStore from 'jobs/bookkeeping/BookkeepingProgressionStore'
import { action, computed, makeObservable } from 'mobx'
import { Id } from 'types/definitions'
import BookkeepingCorrectCycleDialogViewModel from '../BookkeepingCorrectCycleDialog/BookkeepingCorrectCycleDialogViewModel'

export default class BookkeepingSelectCycleViewModel extends ModalViewModel {
  constructor(
    private jobId: Id,
    private bookkeepingProgressionStore: BookkeepingProgressionStore,
    private bookkeepingCorrectCycleDialogVM: BookkeepingCorrectCycleDialogViewModel,
  ) {
    super()
    makeObservable(this)
  }

  /**
   * Returns the bookkeeping progression info.
   */
  @computed
  get bookkeepingProgressionInfo() {
    return this.bookkeepingProgressionStore.bookkeepingProgressions.get(
      this.jobId,
    )
  }

  /**
   * Returns the cycles that can be corrected.
   */
  @computed
  get completedCycles() {
    return this.bookkeepingProgressionInfo?.cycles.filter((c) => c.isCompleted)
  }

  /**
   * Opens the correct cycle dialog with the
   * completed items in the selected cycle.
   * @param selectedCycle
   */
  @action.bound
  selectCycle(selectedCycle?: BookkeepingCycle) {
    if (selectedCycle) {
      this.bookkeepingCorrectCycleDialogVM.open(selectedCycle)
      this.close()
    }
  }
}
